export default __webpack_public_path__ + "static/char-s-11-cht-8552bf098cd4bb13c8275ac7c343b439.png";